
export interface AdminListItem {
  id: string;
  userId: string;
  firstName: string | null;
  lastName: string | null;
  email: string;
  role: string;
  brandId: string | null;
  brandName: string | null;
  profileImgUrl: string | null;
}

export interface AdminDashboardLayout {
  enableSection: {
    crossDomainPortability: boolean,
    coversionAndFunnel: boolean,
    ageVerification: boolean,
    prefillEfficiency: boolean,
    initiatedOtp: boolean,
    trustIds: boolean,
    returningTrustIds: boolean,
    conversionRate: boolean,
    verifiedIdentityMetrics: boolean,
    onceAndDoneMetrics: boolean,
    syndicatedUserOverlap: boolean,
    consentAndActivity: boolean,
    trustIdsTable: boolean,
  }
}

export interface UserUISettings {
  admin_dashboard_layout: AdminDashboardLayout | null
}

export interface User {
  id: string;
  email: string | null,
  phone: string | null,
  user_role_id: number,
  last_login_at: string | null,
  created_at: string,
  updated_at: string,
  admin?: Admin,
  user_ui_settings: UserUISettings | null,
  user_role: UserRole,
  admins?: AdminListItem[] | null;
}

export type AdminUserListItem = User & {
  admin?: Admin & {
    brand: {
      id: string,
      name: string,
      logo_url: string | null,
    }
  }
}

export interface BrandUser {
  user_full_name: string;
  email: string;
  phone: string;
  brand: string;
}

export enum UserRoleName {
  BRAND_ADMIN = "BRAND_ADMIN",
  ROOT_ADMIN = "ROOT_ADMIN",
  VIEWER_ROOT_ADMIN = "VIEWER_ROOT_ADMIN",
  BRAND_CONTRIBUTOR_ADMIN = "BRAND_CONTRIBUTOR_ADMIN",
  BRAND_VIEWER_ADMIN = "BRAND_VIEWER_ADMIN",
  UTA_SUPER_ADMIN = "UTA_SUPER_ADMIN",
  UTA_ADMIN = "UTA_ADMIN",
}

export interface UserRole {
  id: number,
  name: UserRoleName,
  type: 'ADMIN' | 'CLIENT',
  created_at: string,
  updated_at: string,
}

export const USER_ROLE_LABELS: Record<UserRoleName, string> = {
  [UserRoleName.ROOT_ADMIN]: "Root Admin",
  [UserRoleName.VIEWER_ROOT_ADMIN]: "Viewer Root Admin",
  [UserRoleName.BRAND_ADMIN]: "Brand Admin",
  [UserRoleName.BRAND_CONTRIBUTOR_ADMIN]: "Brand Contributor Admin",
  [UserRoleName.BRAND_VIEWER_ADMIN]: "Brand Viewer Admin",
  [UserRoleName.UTA_SUPER_ADMIN]: "UTA Super Admin",
  [UserRoleName.UTA_ADMIN]: "UTA Admin",
};

export const getUserRoleLabel = (name: string): string =>
  USER_ROLE_LABELS[name as UserRoleName] ??
  name.split("_").map((w) => w.charAt(0) + w.slice(1).toLowerCase()).join(" ");

export interface Admin {
  id: string;
  first_name: string | null;
  last_name: string | null;
  profile_img_url: string | null;
  user_id: string;
  brand_id: string | null;
  created_at: string;
  updated_at: string;
  user: User;
}

export interface AddAdminForm {
  email: string;
  firstName?: string;
  lastName?: string;
  role?: UserRoleName;
}

export interface UserPayload {
  email: string,
  userRoleId: number,
  userRoleType: 'ADMIN',
  userId: string,
}

export interface MeResponse {
  email: string;
  phone: string | null;
  userRoleId: number;
  role: UserRoleName;
  brand_id: string | null;
  hasPassword: boolean;
  hasTotp: boolean;
  permissions: string[];
}